/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MedicineResponseDto } from './MedicineResponseDto';
import {
    MedicineResponseDtoFromJSON,
    MedicineResponseDtoFromJSONTyped,
    MedicineResponseDtoToJSON,
    MedicineResponseDtoToJSONTyped,
} from './MedicineResponseDto';

/**
 * 
 * @export
 * @interface GetMedicinesResponseDto
 */
export interface GetMedicinesResponseDto {
    /**
     * List of medicines
     * @type {Array<MedicineResponseDto>}
     * @memberof GetMedicinesResponseDto
     */
    medicines: Array<MedicineResponseDto>;
    /**
     * Total number of medicines
     * @type {number}
     * @memberof GetMedicinesResponseDto
     */
    total: number;
    /**
     * Current page number
     * @type {number}
     * @memberof GetMedicinesResponseDto
     */
    page: number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof GetMedicinesResponseDto
     */
    pageSize: number;
}

/**
 * Check if a given object implements the GetMedicinesResponseDto interface.
 */
export function instanceOfGetMedicinesResponseDto(value: object): value is GetMedicinesResponseDto {
    if (!('medicines' in value) || value['medicines'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    return true;
}

export function GetMedicinesResponseDtoFromJSON(json: any): GetMedicinesResponseDto {
    return GetMedicinesResponseDtoFromJSONTyped(json, false);
}

export function GetMedicinesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMedicinesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'medicines': ((json['medicines'] as Array<any>).map(MedicineResponseDtoFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'pageSize': json['pageSize'],
    };
}

export function GetMedicinesResponseDtoToJSON(json: any): GetMedicinesResponseDto {
    return GetMedicinesResponseDtoToJSONTyped(json, false);
}

export function GetMedicinesResponseDtoToJSONTyped(value?: GetMedicinesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'medicines': ((value['medicines'] as Array<any>).map(MedicineResponseDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

